import styled from 'styled-components'

const HobbiesWrapper = styled.div`
  display: flex;
  @media (${({ theme }) => theme.mq.mobile}) {
    flex-direction: column;
  }
`

const HobbiesTitleWrapper = styled.div`
  background: ${({ theme }) => theme.color.ui3};
  padding: 10px 20px;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? '10px' : 0)};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;

  @media (${({ theme }) => theme.mq.mobile}) {
    width: 100%;
  }
`

const HobbiesUlWrapper = styled.ul`
  padding: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(135px, 1fr));
  grid-gap: 10px;
  margin: 0;
`

const HobbiesLiWrapper = styled.li`
  list-style: none;
  padding: 5px 10px;
  background: ${({ theme }) => theme.color.ui3};
  display: flex;
  align-items: center;
  justify-content: center;
`

const HobbiesTitle = styled.span`
  text-align: center;
  margin-left: 10px;
`

export {
  HobbiesWrapper,
  HobbiesTitleWrapper,
  HobbiesUlWrapper,
  HobbiesLiWrapper,
  HobbiesTitle,
}
